import { useOutletContext, Outlet } from 'react-router-dom'

import './mission-setup.styl'

function MissionSetup() {
  const { map } = useOutletContext()

  return (
    <div className="mission-setup">
      <Outlet context={{ map }} />
    </div>
  )
}

export default MissionSetup
